import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, IconButton, Modal, Fade, Paper } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import axios from "axios";
import toast from "react-hot-toast";
import { URL } from "../config";
import TimeslotModal from "./AddTimeSlotModal";

const TimeslotList = () => {
  const [dataSource, setDataSource] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editTimeslot, setEditTimeslot] = useState(null);

  const fetchTimeslots = async () => {
    try {
      const res = await axios.get(`${URL}/timeslots`);
      setDataSource(res.data);
    } catch {
      toast.error("Failed to fetch time slots");
    }
  };

  useEffect(() => {
    fetchTimeslots();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this time slot?")) return;
    await axios.delete(`${URL}/timeslots/${id}`);
    toast.success("Time slot deleted!");
    fetchTimeslots();
  };

  const columns = useMemo(() => [
    {
      header: "Actions",
      size: 100,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton size="small" onClick={() => { setEditTimeslot(row.original); setModalOpen(true); }}>
            <Edit fontSize="small" sx={{ color: "#174253" }} />
          </IconButton>
          <IconButton size="small" onClick={() => handleDelete(row.original.TimeSlotId)}>
            <Delete fontSize="small" sx={{ color: "#d32f2f" }} />
          </IconButton>
        </Box>
      ),
    },
    { accessorKey: "TimeSlotId", header: "ID", size: 60 },
    { accessorKey: "TimeSlotName", header: "Time Slot Name", size: 200 },
  ], []);

  return (
    <Box sx={{ width: "100%", bgcolor: "#fff", mt: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", fontWeight: 700, fontSize: 22, color: "#174253", letterSpacing: 0.5, borderLeft: "5px solid #174253", pl: 1.5 }}>
          Time Slot List
        </Box>

        <Button
          sx={{
            borderRadius: 25,
            background: "linear-gradient(90deg, #0b8793, #174253)",
            color: "white",
            "&:hover": { background: "linear-gradient(90deg, #174253, #0b8793)" },
          }}
          onClick={() => { setEditTimeslot(null); setModalOpen(true); }}
        >
          Add Time Slot
        </Button>
      </Box>

       <Box sx={{ background: "#fff", borderRadius: "0 0 15px 15px" }}>
              <MaterialReactTable
                columns={columns}
                data={dataSource}
                enableColumnActions={false}
                enableDensityToggle={false}
                enableFullScreenToggle={false}
                enableColumnFilters={false}
                enableHiding={false}
                enableGlobalFilter={false}
                muiTablePaperProps={{ sx: { boxShadow: "none", background: "#fff", borderRadius: "15px" } }}
                muiTableContainerProps={{ sx: { backgroundColor: "#fff", width: "100%", overflowX: "auto", borderRadius: "12px" } }}
                muiTableHeadCellProps={{ sx: { backgroundColor: "#e0e0e0ff", color: "#393e4f", fontWeight: 600, fontSize: "16px", borderBottom: "0.5px solid #e3e5eb", textAlign: "left", height: "63px", paddingTop: "23px" } }}
                muiTableBodyRowProps={{ sx: { backgroundColor: "#fff", "&:hover": { backgroundColor: "#eff6fe" }, "& td": { fontSize: { xs: "12px", sm: "14px" }, p: "8px", borderBottom: "0.5px solid #e3e5eb", height: "54px" } } }}
                initialState={{ pagination: { pageIndex: 0, pageSize: 10 } }}
              />
            </Box>

      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Fade in={modalOpen}>
          <Paper sx={{ bgcolor: "transparent" }}>
            <TimeslotModal
              timeslot={editTimeslot}
              onClose={() => { setModalOpen(false); fetchTimeslots(); }}
            />
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default TimeslotList;
